import React from "react";
import { Box, Typography, Container, Stack, Link, Grid } from "@mui/material";
import { Phone, Email, LocationOn } from "@mui/icons-material";
import { Helmet } from "react-helmet";

const ContactUs = () => {
  return (
    <Box sx={{ bgcolor: "white", color: "black", py: 6 }}>
      {/* Helmet Meta Tags */}
      <Helmet>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="SVR Taxi Service | Call us 9965821750" />
        <meta
          name="description"
          content="Reliable, taxi, service, in Salem, and, across India. Available 24/7 with professional drivers and affordable pricing. Book now for a comfortable journey."
        />
        <meta
          name="keywords"
          content="best cab service in salem, taxi service in Salem, affordable cab service"
        />
        <meta name="author" content="SVR Taxi" />
        <link rel="canonical" href="https://svrtaxi.netlify.app/contact" />
        <meta
          property="og:title"
          content="Contact us 9965821750"
        />
        <meta property="og:locale" content="en_IN" />
        <meta
          property="og:url"
          content="https://svrtaxi.netlify.app/contact"
        />
        <meta
          property="og:image"
          content="https://svrtaxi.netlify.app/VisitingCard.jpg"
        />
        <title>Call us 9965821750 | 24/7 Cab & Cabs Service is Available | Cab & Cabs Service near me</title>
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      {/* Page Content */}
      <Container maxWidth="md">
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: "bold",
            mb: 3,
            textAlign: "center",
            textTransform: "uppercase",
          }}
        >
          Contact SVR Tour's & Travels
        </Typography>

        <Typography
          variant="h6"
          component="h2"
          sx={{
            textAlign: "center",
            color: "text.secondary",
            mb: 4,
          }}
        >
         Call us 9965821750 | Cab & Cabs Service Near Me | Cab Service in Salem
        </Typography>

        <Grid container spacing={4}>
          {/* Address */}
          <Grid item xs={12} sm={6}>
            <Stack
              spacing={2}
              alignItems="flex-start"
              sx={{
                p: 3,
                border: "1px solid #f0f0f0",
                borderRadius: "8px",
                bgcolor: "#fafafa",
              }}
            >
              <LocationOn fontSize="large" sx={{ color: "#4caf50" }} />
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Address
              </Typography>
              <Typography variant="body1">
                289.2/365.a, SRM Thottam Shanmuganagar, Dhadhagapatty, Salem -
                636006, Tamil Nadu
              </Typography>
            </Stack>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} sm={6}>
            <Stack
              spacing={2}
              alignItems="flex-start"
              sx={{
                p: 3,
                border: "1px solid #f0f0f0",
                borderRadius: "8px",
                bgcolor: "#fafafa",
              }}
            >
              <Phone fontSize="large" sx={{ color: "#2196f3" }} />
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Contact Us
              </Typography>
              <Typography variant="body1">
                Phone:{" "}
                <Link href="tel:+919965821750" sx={{ color: "primary.main" }}>
                  +91 9965821750
                </Link>
              </Typography>
              <Typography variant="body1">
                Email:{" "}
                <Link
                  href="mailto:vrsslm92@gmail.com"
                  sx={{ color: "primary.main" }}
                >
                  vrsslm92@gmail.com
                </Link>
              </Typography>
            </Stack>
          </Grid>
        </Grid>

        {/* Footer Message */}
        <Typography
          variant="body2"
          sx={{
            mt: 6,
            textAlign: "center",
            color: "text.secondary",
          }}
        >
          We are available 24/7 to serve you. Book your ride today and experience
          seamless travel with SVR Taxi Services!
        </Typography>
      </Container>
    </Box>
  );
};

export default ContactUs;
